exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".van-button[data-v-0051e834]{font-size:12px;border-radius:0;border:0 solid #ebedf0}.van-button--default[data-v-0051e834]{color:#323233;background-color:#fff;border:0 solid #ebedf0}", ""]);

// exports
